export const WORMHOLE_SLUGS = [
  "wormhole",
  "wormhole-private",
  "mainnet-wormhole",
  "testnet-wormhole",
  "multigov",
]
